/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function i(i){var n;return!!(i&&i.loaded&&"capabilities"in i&&null!=i&&null!=(n=i.capabilities)&&n.operations&&"supportsEditing"in i.capabilities.operations&&!0===i.capabilities.operations.supportsEditing)&&!("editingEnabled"in i&&!i.editingEnabled)}export{i as isEditableLayer};
